import React, { useEffect, useState, useMemo } from "react";
import i18n from ".";

// Cache which modules have already been loaded
const loadedModules = new Set();

const useTranslation = (moduleName) => {
  const [ready, setReady] = useState(loadedModules.has(moduleName));

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      // If already loaded, skip async call
      if (loadedModules.has(moduleName)) {
        setReady(true);
        return;
      }

      try {
        await i18n.loadTranslations(moduleName);

        if (!cancelled) {
          loadedModules.add(moduleName);
          setReady(true);
        }
      } catch (err) {
        console.error(`Error loading translations for: ${moduleName}`, err);
        if (!cancelled) setReady(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [moduleName]);

  const t = useMemo(() => {
    return (key) => {
      return ready ? i18n.t(moduleName, key) : `#${moduleName}:${key}#`;
    };
  }, [ready, moduleName]);

  return t;
};

export { useTranslation };
